import React, { useCallback, useEffect, useRef, useState } from "react";
import CommonLayout from "../../../../Components/CommonLayout/CommonLayout.jsx";
import { useFetchAll } from "../../../../custom/FetchApiHook.jsx";
import BasicTable from "../../../../Components/CommonTable/BasicTable/BasicTable.jsx";
// import { columns, searchBy } from "../../../../service/TaxMasterService.js";
import { MasterApi, PackageApi, UnitApi } from "../../../../App/api/setting.js";
import { useSelector } from "react-redux";
import UnitMeasurementModal from "./PackageMeasurementModal.jsx";
import { Button } from "primereact/button";
// import { DeleteModal } from "../../../../custom/modal/delteModal.jsx";
import style from "../master.module.css";
import { columns, searchBy } from "./PackageMasterService.js";

const PackageMaster = () => {
  const [addPackageModel, setAddPackageModel] = useState(false);
  const [selected, setSelectedData] = useState(null);
  const { value: allPackageData, fetchAllData } = useFetchAll(() =>
    PackageApi.master.getAllPackageMaster()
  );
  const UnitData = allPackageData?.data?.packagingMaster;

 

  console.log("allPackageData:", UnitData);

  const handleClearFilter = () => {
    // setPagination({
    //   page: 1,
    //   limit: 5,
    //   sortOrder: "desc",
    //   filter: {},
    // });
  };
  const handleSearch = useCallback((s) => {
      // setSearch(s);
    }, []);
  
    const debouncedSearch = useCallback(
      () => {
        // if (debounceTimeout.current) {
        //   clearTimeout(debounceTimeout.current);
        // }
        // debounceTimeout.current = setTimeout(() => {
        //   handleSearch(s);
        // }, 1500);
      },
      [handleSearch]
    );
  const handleCellClick = (cell, field = "") => {
    if ((field = "_id")) {
      setAddPackageModel(true);
      setSelectedData(cell);
      console.log("selected:", cell);
      // console.log("field:", field);
    }
  };

  const onPaginatorClick = (e) => {
    if (e) {
      // console.log("Paginator Clicked", e);
      const data = {
        limit: e.rows,
        page: +e.page + 1,
      };
      //   handlePagination && handlePagination(data);
    }
  };

  useEffect(() => {
    fetchAllData();
  }, []);

  return (
    <div className="p-5">
      <CommonLayout />
      <BasicTable
        data={UnitData}
        handleClearFilter={handleClearFilter}
        handleSearch={debouncedSearch}
        onPaginatorClick={onPaginatorClick}
        selectedData={selected}
        columns={columns}
        // handleFilter={handleFilter}
        handleCellClick={handleCellClick}
        SearchBy={searchBy}
        // filters={filters}
        // WeekRange={false}
        button_name="Add"
        handleButton={() => {
          setAddPackageModel(true);
          //   setTaxDataClicked(null);
        }}
      />
      {addPackageModel && (
        <UnitMeasurementModal
        data={selected}
          isOpen={addPackageModel}
          onClose={() => setAddPackageModel(false)}
          // data={taxDataClicked}
          fetchAllData={fetchAllData}
        />
      )}
    </div>
  );
};

export default PackageMaster;
